import api from '../api/axios';

export interface Customer {
  id: number;
  customerNumber: string;
  companyName?: string;
  contactPerson: string;
  email: string;
  phone?: string;
  mobile?: string;
  address?: string;
  city?: string;
  country?: string;
  taxNumber?: string;
  customerType: 'individual' | 'business';
  creditLimit: number;
  paymentTerms?: string;
  notes?: string;
  isActive: boolean;
  website?: string;
  vinNumber?: string;
  plateNumber?: string;
  carMake?: string;
  carModel?: string;
  carYear?: number;
  policyNumber?: string;
  policyStartDate?: string;
  policyEndDate?: string;
  servicePackage?: any;
  createdAt: string;
  updatedAt: string;
}

export const customerService = {
  async getAll(params?: any) {
    const queryParams = {
      populate: '*',
      'pagination[pageSize]': 100,
      ...params
    };
    const response = await api.get('/customers', { params: queryParams });
    return response.data;
  },

  async getById(id: number) {
    const response = await api.get(`/customers/${id}`, {
      params: { populate: '*' }
    });
    return response.data;
  },

  async create(data: Partial<Customer>) {
    const response = await api.post('/customers', { data });
    return response.data;
  },

  async update(id: number, data: Partial<Customer>) {
    const response = await api.put(`/customers/${id}`, { data });
    return response.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/customers/${id}`);
    return response.data;
  },

  async checkCustomer(customerId?: number, customerNumber?: string, vinNumber?: string) {
    const response = await api.post('/customers/check-customer', {
      customerId,
      customerNumber,
      vinNumber
    });
    return response.data;
  }
};

